"use strict";

exports.__esModule = true;
var _AlignmentPicker = require("./AlignmentPicker");
Object.keys(_AlignmentPicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AlignmentPicker[key]) return;
  exports[key] = _AlignmentPicker[key];
});